// src/views/Voicemails/VoicemailsDialog.styles.ts
import {makeStyles} from '@material-ui/core';
import React from "react";


// export type VoicemailsFilterFormClasses = ClassNameMap<'itemsContainer' | 'filterSeparation' | 'timePicker' | 'button'>;

export const useStyles = makeStyles(() => ({
    itemsContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
    },
    filterSeparation: {
        marginBottom: 24,
    },
    timePicker: {
        minWidth: 200,
        marginRight: 16,
    },
    button: {
        minWidth: 120,
        marginLeft: 8,
    },
}));

export type VoicemailsFilterFormClasses = ReturnType<typeof useStyles>;
export type VoicemailsFilterFormProps = {
    values: { from: string; till: string };
    errors: { from?: string; till?: string };
    classes?: VoicemailsFilterFormClasses;
    t: (key: string, options?: any) => string;
    userDateTimeFormat: string;
    handleSubmit: (e?: React.FormEvent) => void;
    setFieldError: (field: string, message: string | undefined) => void;
    onFromChange: (v: any) => void;
    onTillChange: (v: any) => void;
    onSearchClick: () => void;
    dataTestId?: string;
};